import { DescriptionField } from "@dash/description-list";
import { useDialogRoute } from "@dash/dialog";
import { GoogleMap } from "@dash/google-map";
import Decimal from "decimal.js";
import { useMemo } from "react";

import { Region } from "@megaron/crm-contracts";

import { EditRegionOwnerAddressDialog } from "./EditRegionOwnerAddressDialog";
import { RegionOwnerAddress as RegionOwnerAddressType } from "./LocationPicker";

type Props = {
  region: Region;
  regionQueryKey: string | string[];
};

export const RegionOwnerAddress: React.FC<Props> = ({ region, regionQueryKey }) => {
  const address = getAddressFromRegion(region);

  const addressString = useMemo(() => parseCustomerAddressToString(address), [address]);

  const editAddressDialog = useDialogRoute(`/edit-address`, ({ onClose }) => (
    <EditRegionOwnerAddressDialog region={region} onClose={onClose} address={address} regionQueryKey={regionQueryKey} />
  ));

  return (
    <div css={{ display: "flex", flexDirection: "column", gap: "1.5rem", width: "100%" }}>
      <div css={{ display: "flex", flexDirection: "column", gap: "1rem", width: "100%", flexGrow: 0 }}>
        <button
          onClick={editAddressDialog.open}
          css={{ background: "none", border: "none", textAlign: "start", cursor: "pointer", padding: 0 }}
        >
          <DescriptionField label="Adres">{addressString}</DescriptionField>
        </button>

        {address.latitude && address.longitude && (
          <GoogleMap latLng={{ latitude: new Decimal(address.latitude), longitude: new Decimal(address.longitude) }} />
        )}

        {editAddressDialog.element}
      </div>
    </div>
  );
};

export const parseCustomerAddressToString = (address: RegionOwnerAddressType) => {
  if (!address || Object.values(address).every((value) => !value)) return "-";

  return `${address.street}${address.postalCode ? (address.street ? ", " + address.postalCode : address.city) : ""}${
    address.city
      ? address.street || address.postalCode
        ? address.postalCode
          ? " " + address.city
          : ", " + address.city
        : address.postalCode
      : ""
  }${address.country ? ", " + address.country : ""}`;
};

export const getAddressFromRegion = (region: Region): RegionOwnerAddressType => {
  return {
    city: region.addressCity || "",
    street: region.addressStreet || "",
    country: region.addressCountry || "",
    postalCode: region.addressPostalCode || "",
    latitude: region.homeLatitude ? region.homeLatitude.toNumber() : null,
    longitude: region.homeLongitude ? region.homeLongitude.toNumber() : null,
  };
};
